var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9999 5.05762C9.06122 5.05762 5.05762 9.06122 5.05762 13.9999C5.05762 14.9184 5.25164 15.8578 5.5298 16.7277L5.53688 16.7498C5.87992 17.8227 6.1464 18.656 6.31674 19.3002C6.48303 19.9291 6.58876 20.4824 6.53519 20.9545C6.52594 21.036 6.52135 21.0687 6.50784 21.1496C6.4334 21.5951 6.24411 22.0132 5.98778 22.4615C5.90213 22.6112 5.80507 22.7709 5.69702 22.9422H13.9999C18.9386 22.9422 22.9422 18.9386 22.9422 13.9999C22.9422 9.06122 18.9386 5.05762 13.9999 5.05762ZM3.68926 23.2677C3.60622 23.3884 3.55762 23.5346 3.55762 23.6922C3.55762 24.1064 3.8934 24.4422 4.30762 24.4422H13.9999C19.7671 24.4422 24.4422 19.7671 24.4422 13.9999C24.4422 8.2328 19.7671 3.55762 13.9999 3.55762C8.2328 3.55762 3.55762 8.2328 3.55762 13.9999C3.55762 15.1199 3.7923 16.2189 4.10106 17.1845C4.45265 18.2841 4.70722 19.081 4.86659 19.6837C5.0312 20.3062 5.06371 20.6183 5.04475 20.7854C5.04097 20.8187 5.03926 20.8324 5.03763 20.8441C5.03601 20.8557 5.03386 20.8694 5.02834 20.9024C4.99677 21.0914 4.90732 21.3292 4.68566 21.7168C4.46336 22.1056 4.1436 22.5862 3.68926 23.2677Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.33325L14 18.6666M14 18.6666L17.5 15.1666M14 18.6666L10.5 15.1666",
    stroke: "#8F8F8F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.9b7c2e13d40ec575e8ef804556c8985c.svg";
export { ForwardRef as ReactComponent };